// dashboard-frontend/src/components/LeadsManager.js — orquestrador; lógica em features/leads/
import React from "react";
import StyledSelect from "./StyledSelect";
import { useLeadsManagerState } from "../features/leads/useLeadsManagerState";
import { styles } from "../features/leads/leadsStyles";
import { LeadsTabBar } from "../features/leads/LeadsTabBar";
import { LeadsListTab } from "../features/leads/LeadsListTab";
import { LeadsExportTab } from "../features/leads/LeadsExportTab";
import { LeadsWebhookTab } from "../features/leads/LeadsWebhookTab";
import { LeadsEmailTab } from "../features/leads/LeadsEmailTab";
import { LeadsRdStationTab } from "../features/leads/LeadsRdStationTab";
import { LeadsGoogleCalendarTab } from "../features/leads/LeadsGoogleCalendarTab";
import { LeadsConversionTab } from "../features/leads/LeadsConversionTab";
import { LeadsHelpVideo } from "../features/leads/LeadsHelpVideo";

const LeadsManager = () => {
  const vm = useLeadsManagerState();
  const {
    clients,
    selectedClient,
    setSelectedClient,
    bots,
    selectedBot,
    setSelectedBot,
    activeTab,
    setActiveTab,
    SHOW_GOOGLE_CALENDAR_UI,
  } = vm;

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Gerenciamento de Leads</h2>

      <div style={styles.selectContainer}>
        <label htmlFor="clientSelector" style={styles.label}>Selecione um Cliente:</label>
        <StyledSelect
          value={selectedClient}
          onChange={setSelectedClient}
          options={[
            { value: "", label: "-- Selecione um Cliente --" },
            ...clients.map((client) => ({ value: client.id, label: client.name })),
          ]}
          placeholder="-- Selecione um Cliente --"
        />
      </div>

      {selectedClient && (
        <div style={styles.selectContainer}>
          <label htmlFor="botSelector" style={styles.label}>Selecione um Bot (opcional):</label>
          <StyledSelect
            value={selectedBot}
            onChange={setSelectedBot}
            options={[
              { value: "", label: "-- Todos os Bots --" },
              ...bots.map((bot) => ({ value: bot.id, label: bot.name || bot.id })),
            ]}
            placeholder="-- Todos os Bots --"
          />
        </div>
      )}

      {selectedClient && (
        <div style={styles.tabContainer}>
          <LeadsTabBar
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            showGoogleCalendarTab={SHOW_GOOGLE_CALENDAR_UI}
          />

          <div style={styles.tabContent}>
            {activeTab === "leads" && <LeadsListTab vm={vm} />}
            {activeTab === "export" && <LeadsExportTab vm={vm} />}
            {activeTab === "webhook" && <LeadsWebhookTab vm={vm} />}
            {activeTab === "email" && <LeadsEmailTab vm={vm} />}
            {activeTab === "rdstation" && <LeadsRdStationTab vm={vm} />}
            {SHOW_GOOGLE_CALENDAR_UI && activeTab === "google_calendar" && (
              <LeadsGoogleCalendarTab vm={vm} />
            )}
            <LeadsConversionTab vm={vm} />
          </div>
        </div>
      )}

      <LeadsHelpVideo />
    </div>
  );
};

export default LeadsManager;
